<template>
    <settings-wrapper title="Space settings" section="Secrets">
        <secrets-listing :level="2" :entity-id="activeSpaceId" />
    </settings-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import SettingsWrapper from '@/components/SettingsWrapper.vue'

const SecretsListing = () => import('@/components/SecretsListing.vue')

export default {
    name: 'SpaceConfigurationSecrets',
    components: {
        SecretsListing,
        SettingsWrapper
    },
    async created() {
        if (this.activeOrgId && !this.spacesWithPrimarySnapshots.length) {
            await this.$store.dispatch('orgStore/fetchOrgSpaces', this.activeOrgId)
        }
    },
    computed: {
        ...mapState('orgStore', ['spacesWithPrimarySnapshots']),
        activeOrgId() {
            return this.$route.params.oid
        },
        activeSpaceId() {
            return this.$route.params.sid
        }
    },
    watch: {
        spacesWithPrimarySnapshots: {
            immediate: true,
            handler(spaces) {
                if (!this.$route.params.sid && Array.isArray(spaces) && spaces.length) {
                    this.$router.replace({
                        name: this.$route.name,
                        params: {
                            ...this.$route.params,
                            sid: spaces[0].sid
                        },
                        query: { ...this.$route.query }
                    })
                }
            }
        }
    }
}
</script>
